<template>
  <button :style="{...styles.base,...backgroundImageStyle}"
          :class="getCss('link-style')" @click="handleClick"></button>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
// import { common, componentBaseMixin } from '../../../../ceiba-base-components';
import Vue from 'vue';

let msdkiOSHandler;
//  6 跳转动态俱乐部 需要登录态
const JUMP_TYPE_RECOMMEND_CLUB = 6;
const JUMP_TYPE_RECOMMEND_CLUB_FROM_APP = 7;
const JUMP_TYPE_RECOMMEND_CLUB_FROM_H5_TO_APP = 8;

//  9 跳转动态俱乐部 不需要登录态
const JUMP_TYPE_RECOMMEND_CLUB_WITHOUT_LOGIN = 9;
const JUMP_TYPE_RECOMMEND_CLUB_FROM_APP_WITHOUT_LOGIN = 10;
const JUMP_TYPE_RECOMMEND_CLUB_FROM_H5_TO_APP_WITHOUT_LOGIN = 11;
const RECOMMEND_TYPE_CLUB_ACCOUNT = 1; // 根据账号类型推荐
// const RecommendTypeClubAll = 2;
const MULTI_LINK_RANDOM_JUMP_FROM_CURRENT = 12; // 配置多链接随机跳转(直接跳)
const MULTI_LINK_RANDOM_JUMP_FROM_APP = 13; //  配置多链接随机跳转(强制跳转app在点击跳目标)
const MULTI_LINK_RANDOM_JUMP_FROM_H5_TO_APP = 14; //  配置多链接随机跳转(强制跳转app后且直接跳转目标)
export default {
  name: 'CTgclubLink',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'Tgclub-link-',
      distributedData: '',
      clubLinkListInfo: [], // 动态推荐俱乐部链接
      multiRandomLinks: [], // 配置多链接跳转并且随机跳转一个地址
    };
  },
  computed: {
    backgroundImageStyle() {
      return {
        backgroundImage: this.configurationData.bgImage ? `url(${this.configurationData.bgImage})` : 'none',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      };
    },
    isApp() {
      return this.$ast.isAPP();
    },
    isIos() {
      return this.$platform.isIos;
    },
    isAndroid() {
      return this.$platform.isAndroid;
    },
    isWX() {
      //  ios safari | 心悦app | wx客户端
      const isWxCookie = common.tool.getCookie('acctype') === 'wx';
      console.log('isWxCookie = ', isWxCookie);
      return isWxCookie ? isWxCookie : this.$platform.isWX;
    },
    defaultKeyArr() {
      return this.configurationData?.defaultKey?.split('|') ?? [];
    },
    defaultKeyValue() {
      const { defaultKeyValue = '' } = this.configurationData;
      if (typeof defaultKeyValue === 'string' && defaultKeyValue.length > 0) {
        const tempArray = defaultKeyValue.split('&').map(item => item.split('='));
        return Object.fromEntries(tempArray);
      }
      return {};
    },
    riskControlText() {
      return  this.configurationData.riskControlText || '前往心悦微官网参与（手机浏览器打开xinyue.qq.com）';
    },
  },
  async mounted() {
    console.log('CTgclubLink configurationData=', this.configurationData);
    this.eventListen();
    await this.initialize();
  },
  methods: {
    eventListen() {
      const { isAcceptDistributedData = false } = this.configurationData;
      if (isAcceptDistributedData === true) {
        this.$eventBus.$on('ceiba:common:events:distributed-data', ({ link }) => {
          if (link) {
            this.distributedData = link;
          }
        });
      }
    },
    async initialize() {
      if (this.$isInEditor) return;
      let { jumpType = 1 } = this.configurationData;
      jumpType = parseInt(jumpType, 10);
      if (jumpType === 5) {
        this.initLoadAppFromGame();
      }
      // 需要登录态
      if (jumpType === JUMP_TYPE_RECOMMEND_CLUB
        || jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_APP
        || jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_H5_TO_APP) {
        this.$onLogined(async () => {
          this.initRecommendJumpClubLink();
        });
      }
      // 没有登录态
      if (jumpType === JUMP_TYPE_RECOMMEND_CLUB_WITHOUT_LOGIN
        || jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_APP_WITHOUT_LOGIN
        || jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_H5_TO_APP_WITHOUT_LOGIN) {
        this.initRecommendJumpClubLink();
      }

      //  配置多链接随件跳转初始化
      if (jumpType === MULTI_LINK_RANDOM_JUMP_FROM_CURRENT
        || jumpType === MULTI_LINK_RANDOM_JUMP_FROM_APP
        || jumpType === MULTI_LINK_RANDOM_JUMP_FROM_H5_TO_APP) {
        let { multiRandomLinkList = [] } = this.configurationData;
        multiRandomLinkList = multiRandomLinkList || [];
        if (multiRandomLinkList.length > 0) {
          this.multiRandomLinks = multiRandomLinkList.filter(i => !!i.url).map(i => i.url);
          console.log('---------this.multiRandomLinks =', this.multiRandomLinks);
        }
      }
    },

    // 如果在ios，app外跳转，延迟一定时间后弹提示
    checkIosJumpShowInfo() {
      if (this.isIos
        && !this.isApp
        && this.configurationData.showInfoTime
        && this.configurationData.iosJumpInfo) {
        const showInfoTimeSecond = this.configurationData.showInfoTime * 1000;
        setTimeout(() => {
          this.$alert(this.configurationData.iosJumpInfo);
        }, showInfoTimeSecond);
      }
    },
    // 跳转上报
    reportFunc(link) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: 'open_url',
          eventData: { url: link },
        };
        this.reportClickRaw(params);
        console.log('reportFunc open_url data =', params);
      }
    },
    checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText) {
      if (this.isIos && limitIosJumpText) {
        this.$alert({ msg: limitIosJumpText });
        return false;
      }
      if (this.isAndroid && limitAndroidJumpText) {
        this.$alert({ msg: limitAndroidJumpText });
        return false;
      }
      return true;
    },
    checkJumpTime(startJumpTime, msg) {
      const getTimeStamp = function (time) {
        if (time) {
          // ios 的时间格式需要更改一下
          // eslint-disable-next-line no-param-reassign
          time = time.replace(/-/g, '/');
          return parseInt(new Date(time).getTime() / 1000, 10);
        }
        return parseInt(new Date().getTime() / 1000, 10);
      };
      if (startJumpTime && msg && getTimeStamp() <= getTimeStamp(startJumpTime)) {
        this.$alert({ msg });
        return false;
      }
      return true;
    },
    confirmFunc(androidConfirmText, iosConfirmText) {
      if (this.isIos && iosConfirmText) {
        return window.confirm(iosConfirmText);
      }
      if (this.isAndroid && androidConfirmText) {
        return window.confirm(iosConfirmText);
      }
      return false;
    },
    // 用户填写的跳转地址 如果没有trace_id  则加上
    handleLinkAddTraceId(link) {
      const currentTraceId = common.tool.getQueryParams('trace_id', link);
      // 已经有trace_id
      if (currentTraceId) {
        return link;// 原跳转地址已经有trace_id
      }
      return common.tool.setUrlParam('trace_id', this?.reportExt?.trace_id, link);
    },
    // 获取链接上的参数
    getInviteCodeFromUrl(arr, link) {
      let newLink = link;
      arr.forEach((v, i) => {
        console.log('refreshFromAPI.paramsStr.v', v);
        let getVal = common.tool.getQueryParams(arr[i]) || '';
        if (getVal.length === 0) {
          getVal = this.defaultKeyValue[arr[i]] || '';
        }
        console.log('refreshFromAPI.paramsStr.getVal', getVal);
        newLink = common.tool.setUrlParam(`${v}`, `${getVal}`, newLink);
      });
      return newLink;
    },
    async doSleep(time) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    async syncToLogicStatus(url) {
      if (!url) {
        return false;
      }
      const domain = url.split('//')[1]?.split('/')[0];
      if (!domain) {
        return false;
      }
      await new Promise((resolve) => {
        try {
          Vue.prototype.$miloCore?.loginStatus?.syncToQQ(domain, {
            appid: this.$store?.getters?.userAuth?.['T-APPID'] || '',
            openid: this.$store?.getters?.userAuth?.['T-OPENID'] || '',
            access_token: this.$store?.getters?.userAuth?.['T-ACCESS-TOKEN'] || '',
            acctype: this.$store?.getters?.userAuth?.['T-ACCOUNT-TYPE'] || '',
          }, () => {
            console.log(' syncToLogicStatus sync login status');
            resolve();
          });
        } catch (err) {
          console.error('syncToLogicStatus syncToQQ==', err);
        }
      });
    },
    handleClick() {
      this.handleClickEvent(); // 普通点击事件
      this.configurationData.jumpType = parseInt(this.configurationData.jumpType, 10) || 1;
      // 1 拉起App内点击在跳转
      // 2 拉起App内直接跳转
      // 3 h5直接跳转
      // 4 跳转手机浏览器下载apk
      // 5 从游戏类跳转到心悦app
      // 6 动态推荐俱乐部跳转
      const {
        startJumpTime, msg, jumpType = 1, androidConfirmText, iosConfirmText,
        limitAndroidJumpText, limitIosJumpText, needSyncLoginStatus = false,
      } = this.configurationData;
      let { link } = this.configurationData;
      link = this.distributedData || link;
      // app内区分 6.0 和 5.0版本 不同跳转链接
      const { appFiveVersionLink = '', appSixVersionLink = '' } = this.configurationData?.linkList?.[0] ?? {};
      if (this.isApp && appFiveVersionLink && appSixVersionLink) {
        // app版本为6.0或以上
        if (this.appVersion(['6', '0', '0'])) {
          link = appSixVersionLink;
        }
        if (this.appVersion(['5', '0', '0']) && !this.appVersion(['6', '0', '0'])) {
          link = appFiveVersionLink;
        }
      }

      console.log('link version 5.0or6.0', link);

      if (this.defaultKeyArr.length > 0) {
        console.log('refreshFromAPI.defaultKeyArr', this.defaultKeyArr);
        link = this.getInviteCodeFromUrl(this.defaultKeyArr, link);
        console.log('refreshFromAPI.paramsArr', link);
      }

      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source']);

      const that = this;
      const jump = async (link) => {
        // 跳转前风控判定
        if (link && that.riskControlFlag &&  that.checkUrlRuleType && that.checkUrlRuleType(link)) {
          that.$alert({ msg: that.riskControlText });
          return false;
        }
        // 当url存在trace_id的时候跳转（或者拉起app）的时候带到下游去，如果没有就生成一个带到下游去
        that.reportFunc(link);
        that.reportFlush();
        console.log('jump link begin sleep  200 ms ');
        await that.doSleep(200);
        console.log('jump link end sleep  200 ms ');
        //  tgclub://  协议的目标地址 不需要同步登录态
        if (needSyncLoginStatus === true && link.indexOf('tgclub://') === -1) {
          console.log('access syncToLogicStatus  ');
          await that.syncToLogicStatus(link);
        }
        // eslint-disable-next-line no-param-reassign
        link = that.handleLinkAddTraceId(link);
        const viaSource = common.tool.getQueryParams('via_source', link);
        if (viaSource) {
          // via_source 出现 “|”  导致心悦app ios跳不动
          // eslint-disable-next-line no-param-reassign
          link = common.tool.setUrlParam('via_source', encodeURIComponent(viaSource), link);
        }
        console.log('【最终跳转地址是】', 'link', link);
        if (window.UPBridge && this.isApp) {
          // 心悦openNewPage方法 的 不支持 tgclub://协议跳转
          if (link.indexOf('tgclub://') === -1) {
            // window.Tgclub.openNewPage(decodeURIComponent(link));
            window.UPBridge.openNewWebview({ url: decodeURIComponent(link) });
          } else {
            window.location.href = link;
          }
          return;
        }
        // 其他业务跳转
        this.$ast.openView({ url: link });
      };
      this.checkIosJumpShowInfo();
      if (jumpType === 1 || jumpType === 2) {
        if (!this.checkJumpTime(startJumpTime, msg)) return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return false;
        if (!this.isApp) {
          this.reportFunc(link);
          if (jumpType === 1) {
            this.$ast.gotoAPP();
            return false;
          }
          // h5直接跳转搭配app打开
          if (jumpType === 2) {
            if (link.indexOf('tgclub://') > -1) {
              // tgclub 协议
              window.location.assign(link);
            } else {
              //  http 协议的
              this.$ast.gotoAPP(link);
            }
            return false;
          }
          return false;
        }
        jump(link);
        return;
      }

      if (jumpType === 3) {
        if (!this.checkJumpTime(startJumpTime, msg)) return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return false;
        const via = common.tool.getQueryParams('via');
        if (via.indexOf('spark') >= 0) {
          // 其他业务跳转
          window.location.href = link;
          return;
        }
        jump(link);
        return;
      }
      if (jumpType === 4) {
        if (!this.checkJumpTime(startJumpTime, msg)) return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return false;
        this.reportFunc(link);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = link;
        document.getElementsByTagName('body')[0].appendChild(iframe);
        return;
      }
      // 从游戏类跳转到心悦app
      if (jumpType === 5) {
        if (!this.checkJumpTime(startJumpTime, msg)) return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return false;
        const jumpToApp = (url) => {
          that.reportFunc(url);
          setTimeout(() => {
            const iframe = document.createElement('iframe');
            iframe.src = `mqqapi://forward/url?version=1&src_type=web&url_prefix=${common.Base64.encode(url)}`;
            iframe.style.display = 'none';
            document.body.appendChild(iframe);
          }, 500);
        };
        if (/ipad|iphone|ipod/ig.test(navigator.userAgent.toLowerCase())) {
          this.reportFunc(link);
          console.log('OpenURLInSafiri msdkiOSHandler', msdkiOSHandler);
          if (typeof msdkiOSHandler === 'function') {
            msdkiOSHandler('OpenURLInSafiri', `tgclub://redirect?url=${encodeURIComponent(link)}`, (response) => {
              console.log('OpenURLInSafiri', response);
            });
          } else {
            jumpToApp(link);
          }
        } else {
          this.reportFunc(link);
          this.$ast.gotoAPP(link);
        }
        return;
      }
      // 有登录态动态推荐加入俱乐部
      if (jumpType === JUMP_TYPE_RECOMMEND_CLUB
        || jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_APP
        || jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_H5_TO_APP) {
        if (!this.checkJumpTime(startJumpTime, msg)) return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return false;

        // 跳转需要登录态
        if (!this.isLogin) {
          return this.$alert({ msg: '请先登录' });
        }

        // 跳转需要登录态
        if (!this.$ast.isAPP() && jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_APP) {
          return this.$ast.gotoAPP();
        }

        const { length } = this.clubLinkListInfo;
        if (length === 0) {
          return this.$alert({ msg: '暂无俱乐部推荐' });
        }
        // eslint-disable-next-line max-len,vue/max-len
        const clubLink = length === 1 ? this.clubLinkListInfo[0] : this.clubLinkListInfo[Math.floor((Math.random() * length))];
        if (clubLink.indexOf('tgclub://') > -1 && !this.$ast.isAPP()) {
          return this.$ast.gotoAPP();
        }
        if (!this.$ast.isAPP() && jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_H5_TO_APP) {
          return this.$ast.gotoAPP(clubLink);
        }
        // 当前环境跳转
        return jump(clubLink);
      }
      // 没有登录态动态推荐加入俱乐部
      if (jumpType === JUMP_TYPE_RECOMMEND_CLUB_WITHOUT_LOGIN
        || jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_APP_WITHOUT_LOGIN
        || jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_H5_TO_APP_WITHOUT_LOGIN) {
        if (!this.checkJumpTime(startJumpTime, msg)) return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return false;
        // 跳转需要登录态
        if (!this.$ast.isAPP() && jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_APP_WITHOUT_LOGIN) {
          return this.$ast.gotoAPP();
        }
        const { length } = this.clubLinkListInfo;
        if (length === 0) {
          return this.$alert({ msg: '暂无俱乐部推荐' });
        }
        // eslint-disable-next-line max-len,vue/max-len
        const clubLink = length === 1 ? this.clubLinkListInfo[0] : this.clubLinkListInfo[Math.floor((Math.random() * length))];
        if (clubLink.indexOf('tgclub://') > -1 && !this.$ast.isAPP()) {
          return this.$ast.gotoAPP();
        }
        if (!this.$ast.isAPP() && jumpType === JUMP_TYPE_RECOMMEND_CLUB_FROM_H5_TO_APP_WITHOUT_LOGIN) {
          return this.$ast.gotoAPP(clubLink);
        }
        // 当前环境跳转
        return jump(clubLink);
      }

      // ############实现多链接配置随机跳转 并且随机跳转一个
      if (jumpType === MULTI_LINK_RANDOM_JUMP_FROM_CURRENT
        || jumpType === MULTI_LINK_RANDOM_JUMP_FROM_APP
        || jumpType === MULTI_LINK_RANDOM_JUMP_FROM_H5_TO_APP) {
        if (!this.checkJumpTime(startJumpTime, msg)) return;
        if (!this.checkLimitJumpByDevice(limitIosJumpText, limitAndroidJumpText)) return false;
        if (this.confirmFunc(androidConfirmText, iosConfirmText)) return false;
        // 跳转需要登录态
        if (!this.$ast.isAPP() && jumpType === MULTI_LINK_RANDOM_JUMP_FROM_APP) {
          return this.$ast.gotoAPP();
        }
        const { length } = this.multiRandomLinks;
        if (length === 0) {
          return this.$alert({ msg: '暂无可用跳转目标地址，请稍后尝试' });
        }
        const index = Math.floor((Math.random() * length));
        const targetLink = length === 1 ? this.multiRandomLinks[0]
          : this.multiRandomLinks[index];
        if (targetLink.indexOf('tgclub://') > -1 && !this.$ast.isAPP()) {
          return this.$ast.gotoAPP();
        }
        if (!this.$ast.isAPP() && jumpType === MULTI_LINK_RANDOM_JUMP_FROM_H5_TO_APP) {
          return this.$ast.gotoAPP(targetLink);
        }
        // 当前环境跳转
        return jump(targetLink);
      }
      // ############实现多链接配置随机跳转 并且随机跳转一个
    },
    doTaskAction(taskIdRemarkKey, setSessionStorage) {
      if (taskIdRemarkKey) {
        // eslint-disable-next-line no-underscore-dangle
        this.__taskIdRemarkKey__ = taskIdRemarkKey;
        setSessionStorage && window.sessionStorage.setItem(taskIdRemarkKey, 1);
        this.handleClick();
      }
    },
    // 初始化  https://img.ssl.msdk.qq.com/wiki/msdkJsAdapter.js
    initLoadAppFromGame() {
      let uniqueId = 1;
      const observers = [];
      const log = (message, data) => {
        const log = document.getElementById('log');
        const el = document.createElement('div');
        el.className = 'logLine';
        // eslint-disable-next-line no-plusplus
        el.innerHTML = `${uniqueId++}. ${message}:<br/>${JSON.stringify(data)}`;
        if (log?.children?.length) {
          log.insertBefore(el, log.children[0]);
        } else if (log) {
          log.appendChild(el);
        } else {
          //
        }
      };
      const msdkNativeCallback = (data) => {
        for (let i = 0; i < observers.length; i++) {
          const observer = observers[i];
          if (typeof observer !== 'undefined' && observer instanceof Function) {
            observer(data);
          }
        }
      };
      const connectWebViewJavascriptBridge = (callback) => {
        if (window.WebViewJavascriptBridge) {
          callback(window.WebViewJavascriptBridge);
        } else {
          document.addEventListener('WebViewJavascriptBridgeReady', () => {
            callback(window.WebViewJavascriptBridge);
          }, false);
        }
      };

      connectWebViewJavascriptBridge((bridge) => {
        bridge.init((message, responseCallback) => {
          log('JS got a message', message);
          const data = {
            'Javascript Responds': 'Wee!',
          };
          log('JS responding with', data);
          responseCallback(data);
        });
        bridge.registerHandler('msdkNativeCallback', (data) => {
          msdkNativeCallback(data);
        });
        msdkiOSHandler = bridge.callHandler;
      });
    },
    /**
     * 判断APP版本是否大于等于给定版本
     * @param {string[]} criticality 给定版本 如 ['5', '8', '4']
     */
    appVersion(criticality) {
      if (typeof (criticality) !== 'object') {
        return false;
      }
      let str = navigator.userAgent.toLowerCase();
      if (str.match('tgclub') === null) {
        return false;
      }
      str = str.substr(str.indexOf('tgclub/') + 7, 12);
      const versionArr = str.split('.');
      if (+versionArr[0] > +criticality[0]) {
        return true;
      }
      if (versionArr[0] === criticality[0] && +versionArr[1] > +criticality[1]) {
        return true;
      }
      if (versionArr[0] === criticality[0] && versionArr[1] === criticality[1]) {
        if (!(/ipad|iphone|ipod/ig.test(navigator.userAgent.toLowerCase()))) {
          if (parseInt(versionArr[2], 10) >= criticality[2]) {
            return true;
          }
          return false;
        }
        const helpArr = versionArr[2].split(' ');
        if (parseInt(helpArr[0], 10) >= criticality[2]) {
          return true;
        }
        return false;
      }
      return false;
    },
    /**
     *
     *  拉取俱乐部的推荐方式 1 wx 2 qq 3 all
     * @returns {string|string}
     */
    getRecommendClubType() {
      let { recommendClubType = RECOMMEND_TYPE_CLUB_ACCOUNT } = this.configurationData;
      recommendClubType = parseInt(recommendClubType, 10) || RECOMMEND_TYPE_CLUB_ACCOUNT;
      if (recommendClubType === RECOMMEND_TYPE_CLUB_ACCOUNT) {
        return this.isWX ? '1' : '2';
      }
      return '3';
    },
    async initRecommendJumpClubLink() {
      const extParams = {};
      extParams['4'] = JSON.stringify({
        player_club_plat: this.getRecommendClubType(),
      });
      const params = { scene: 127, gid: this.$actInfo.gid, params: extParams };
      const response = await Vue.prototype.$requestInstance
        .post('https://bgw.xinyue.qq.com/doraemon.FeedsShowPbSrv/PbGetCommonRecommendEncodeCardByScene', params);
      console.log('initRecommendJumpClubLink response = ', response);
      const { ret, msg, out = [] } = response;
      if (ret !== '0') {
        this.clubLinkListInfo = [];
        return this.$alert({ msg: msg || '获取推荐俱乐部信息失败' });
      }
      if (out.length === 0) {
        this.clubLinkListInfo = [];
        return false;
      }
      const clubInfoLinks = out.map((item) => {
        if (typeof item.encoded_card === 'string' && item) {
          const temp = JSON.parse(item.encoded_card) || {};
          const { card_redirect_url: url, trace_id: traceId } = temp.card_meta || {};
          return { url, traceId };
        }
        return {};
      }).filter(i => !!i.url);
      console.log('----clubInfoLinks =', clubInfoLinks);
      const clubLinkInfo = [];
      for (const item of clubInfoLinks) {
        // 当前版本4.3.13 common.tool.setUrlParam  对hash参数有bug 先不使用
        clubLinkInfo.push(this.setUrlParam('trace_id', item.traceId, decodeURIComponent(item.url)));
      }
      this.clubLinkListInfo = clubLinkInfo;
      console.log('----clubLinkListInfo =', this.clubLinkListInfo);
    },
    setUrlParam(name, value, link) {
      let url = link || location.href;
      const reg = new RegExp(`[?&#]${name}=([^&#]*)`, 'gi');

      const matches = url.match(reg);

      const key = `{key${new Date().getTime()}}`;
      let strArr;

      if (matches && matches.length > 0) {
        strArr = matches[matches.length - 1];
      } else {
        strArr = '';
      }
      const extra = `${name}=${value}`;
      // 当原url中含有要替换的属性:value不为空时，仅对值做替换,为空时，直接把参数删除掉
      if (strArr) {
        const first = strArr.charAt(0);
        url = url.replace(strArr, key);
        url = url.replace(key, value ? first + extra : '');
      } else if (value) {
        // 当原url中不含有要替换的属性且value值不为空时,直接在url后面添加参数字符串
        if (url.indexOf('?') > -1) {
          url += `&${extra}`;
        } else {
          url += `?${extra}`;
        }
      }
      // 其它情况直接返回原url
      return url;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
